import { useAccountGovernanceMaps } from 'features/account/hooks/useAccountGovernanceMaps'

export function useGovernanceMaps() {
  const { data, isLoading: loading, error } = useAccountGovernanceMaps()

  const allowUsersToCreatePublicMaps = data?.allowUsersToCreatePublicMaps || false
  const allowUsersToManagePDFReports = data?.allowUsersToManagePDFReports || false
  const allowUsersToManageViewportDataExport = data?.allowUsersToManageViewportDataExport || false
  return {
    loading,
    error,
    data,
    allowUsersToCreatePublicMaps,
    allowUsersToManagePDFReports,
    allowUsersToManageViewportDataExport
  }
}
